<app-z-dialog
  [title]="data().title"
  [contentTemplate]="contentTemplate"
  [actionButtonsTemplate]="buttonsTemplate"
>
</app-z-dialog>

<ng-template #contentTemplate>
  <app-form-grid [formGroupRef]="data().formGroup" [inputs]="data().inputs">
  </app-form-grid>
</ng-template>
<ng-template #buttonsTemplate>
  <z-button
    *ngIf="!data().formGroup?.disabled"
    [disabled]="data().formGroup?.invalid"
    icon="add_circle_outline"
    [label]="(dialogRef ? 'add' : 'edit') | transloco"
    (clicked)="confirm()"
  >
  </z-button>
</ng-template>
